import axios from 'axios';
import { parse, stringify } from 'qs';
import { clearSession } from '../auth/utils';

const GuestHttp = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const AuthenticatedHttp = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: {
    encode: parse,
    serialize: (params) => stringify(params, { arrayFormat: 'comma' }),
  },
});

const generateCSRF = async () => {
  const baseUrl = process.env.REACT_APP_API_URL.replace(/\/$/, '');
  const csrfResponse = await axios.get(`${baseUrl}/get-csrf-token/`, { withCredentials: true });
  const { csrfToken } = csrfResponse.data;
  return csrfToken
}

AuthenticatedHttp.interceptors.request.use(async (config) => {
  const methodsToProtect = ['post', 'put', 'patch', 'delete'];

  if (methodsToProtect.includes(config.method)) {
    try {
      const csrfToken = await generateCSRF();
      if (csrfToken) {
        config.headers['X-CSRFToken'] = csrfToken;
      }
    } catch (error) {
      console.error('Falha ao obter o token CSRF:', error);
      return Promise.reject(error);
    }
  }

  return config;
});

AuthenticatedHttp.interceptors.response.use(
  (response) => response,
  async (error) => {
    const refreshToken = localStorage.getItem('refreshToken');

    if (!refreshToken) {
      if (error.response.status !== 429) {
        clearSession();
      }
      return Promise.reject(error);
    }

    // const originalRequest = error.config;
    // if (error.response.status === 401) {
    //   return GuestHttp.post('/token/refresh/', { refresh: refreshToken })
    //     .then(({ data: { access, refresh } }) => {
    //       setSession({ accessToken: access, refreshToken: refresh });
    //       originalRequest.headers.Authorization = `Bearer ${access}`;
    //       return AuthenticatedHttp(originalRequest);
    //     })
    //     .catch(() => {
    //       if (error.response.status === 401) {
    //         window.location.href = '/auth/login';
    //       }
    //       clearSession();
    //     });
    // }

    return Promise.reject(error);
  }
);

export { AuthenticatedHttp, GuestHttp, generateCSRF };
